import { useAppSelector } from '@/redux/hooks'
import { useTranslate } from '@/hooks'
import { PortalFooter } from '@/ui/layout/portal-footer'
import { TermsAndConditions } from './terms-and-conditions'
import { LanguageSelect } from './language-select'
import { LoginForm } from './login-form'

export const HorizontalLoginLayout = ({
  children
}: {
  children?: React.ReactNode
}) => {
  const { translate } = useTranslate()

  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  const logoUrl = settings.branding?.logo_url
  const title = settings.branding?.title
  const backgroundUrl = settings.branding?.background_image_url
  const desktopLogoHeight = settings.branding?.logo_height_desktop
  const mobileLogoHeight = settings.branding?.logo_height_mobile
  const bannerTextColor = settings.branding?.background_text_color

  return (
    <div className="relative flex h-dvh flex-col">
      <div className="absolute right-4 top-4 z-10 w-32">
        <LanguageSelect />
      </div>
      <div className="relative h-[415px] max-h-full w-full bg-neutral-200">
        {backgroundUrl ? (
          <img
            src={backgroundUrl}
            height={415}
            className="absolute left-0 top-0 size-full object-cover"
            alt=""
          />
        ) : null}
        <div className="absolute bottom-10 left-4 space-y-5 md:bottom-16 md:left-8">
          {logoUrl ? (
            <img
              style={
                {
                  '--logo-desktop-height': desktopLogoHeight ?? '2rem',
                  '--logo-mobile-height': mobileLogoHeight ?? '1.5rem'
                } as React.CSSProperties
              }
              width={285}
              height={70}
              src={logoUrl}
              alt={title}
              className="h-[var(--logo-mobile-height)] w-auto object-contain md:h-[var(--logo-desktop-height)]"
            />
          ) : null}
          {children ? null : (
            <header className="max-w-lg space-y-2 text-left">
              <h1
                className="text-xl [font-weight:750] [text-wrap:balance] md:text-3xl"
                style={{ color: bannerTextColor }}
                dangerouslySetInnerHTML={{
                  __html: translate('landing_title')
                }}
              />
              <h2
                className="text-base [font-weight:500] [text-wrap:pretty]"
                style={{ color: bannerTextColor }}
                dangerouslySetInnerHTML={{
                  __html: translate('landing_subtitle')
                }}
              />
            </header>
          )}
        </div>
      </div>
      <div className="mx-auto flex w-full max-w-96 flex-1 flex-col items-center justify-center gap-6 bg-white px-4 pb-4 pt-6">
        {children ?? (
          <>
            <LoginForm />
            <TermsAndConditions />
          </>
        )}
        <PortalFooter />
      </div>
    </div>
  )
}
